export const GATE_STEP_LABELS = {
  email: "Só e-mail",
  profile: "Nome + telefone",
  sales_phone: "WhatsApp (vendas)",
  sales_name: "Perfil completo (vendas)",
  group_offered: "Grupo oferecido",
  group_clicked: "Clicou no grupo / WPP",
  wpp_clicked: "Foi para o WhatsApp",
  vip_lead: "VIP — aceita R$ 4k+",
  downsell: "Downsell — abaixo de R$ 4k",
};

export function formatGateDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString("pt-BR")} às ${d.toLocaleTimeString("pt-BR").slice(0, 5)}`;
  } catch {
    return "—";
  }
}

export function gateInAppLabel(inApp) {
  if (!inApp) return null;
  const map = {
    instagram: "Instagram (in-app)",
    facebook: "Facebook (in-app)",
    tiktok: "TikTok (in-app)",
  };
  return map[inApp] || inApp;
}
